export const APP_INSTAGRAM = 'https://www.instagram.com/bagchatter_official/?igshid=MzRlODBiNWFlZA%3D%3D';
export const APP_FACEBOOK = 'https://www.facebook.com/bagchatterofficial?mibextid=JRoKGi';
